import './ActionBlock.scss'
import {Block, Text, Button} from '..'

interface ActionBlockProps {
  icon: JSX.Element
  title: string
  text: string
  buttonText: string
  onClick: () => void
}

export default function ActionBlock({
  icon,
  title,
  text,
  buttonText,
  onClick,
}: ActionBlockProps) {
  return (
    <Block className="ActionBlock" type="grey">
      <div className="ActionBlock-Content">
        {icon}
        <Text as="h2" size="4xl" mt={12} mb={20}>
          {title}
        </Text>
        <p className="ActionBlock-Text">{text}</p>
        <Button onClick={onClick}>{buttonText}</Button>
      </div>
    </Block>
  )
}
